module.exports = __webpack_public_path__ + "static/img/文案策划-电商文案.66eb17d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/goods/CPK10008/文案策划-电商文案.png
// module id = vd1r
// module chunks = 1